import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBrief } from "../types/IBrief";
import { IBriefResource } from "../types/IBriefResource";

export type IBriefDuplicateMutationParameters = {
    brief: RelationalValue<IBriefResource>;
};

export type IBriefDuplicateMutationResult = IBrief;

export const briefDuplicateMutation: IApiMutationFunction<IBriefDuplicateMutationParameters> = ({ brief }) => {
    return {
        method: "POST",
        url: "/briefs/duplicate",
        data: {
            uuid: mapRelationalValue(brief),
        },
    };
};

export const useBriefDuplicateMutation = createApiMutationHook<
    IBriefDuplicateMutationParameters,
    IBriefDuplicateMutationResult
>(briefDuplicateMutation);
